import * as dc from "dc";
let idcount = 0;

export const MODE_CHECKBOX = "checkboxes";
export const MODE_TEXTINPUT_AUTOCOMPLETE = "textinput-autocomplete";
export const MODE_TEXTINPUT_DROPDOWN_SELECT = "textinput-dropdown-select";
export const MODE_TEXTINPUT_TIME_INTERVAL = "time-interval";
export class TextChart extends dc.BaseMixin {
    constructor(parentElementSelector) {
        super();
        this.parentElementSelector = parentElementSelector;
        this._dimension = null;
        this._group = null;
        this._chartGroup = dc.constants.DEFAULT_CHART_GROUP;
        this._valueAccessor = d => d.value;
        this._filterState = null;
        this._hideInactiveItems = false;

        dc.chartRegistry.register(this, this._chartGroup);

        // add listner for all filter-events in same chartgroup
        dc.chartRegistry.list(this._chartGroup).forEach(chart => {
            chart.on('filtered', () => {
                console.log(`Filters for chart ${chart.anchorName()}:`, chart.filters());
                if (typeof this.onFiltered === "function") {
                    this.onFiltered(); // Notify parent component
                }
                this._doRedraw();
            });
        });
    }

    dimension(dimension) {
        if (!arguments.length) return this._dimension;
        this._dimension = dimension;
        return this;
    }

    group(group) {
        if (!arguments.length) return this._group;
        this._group = group;
        console.log("Group contents:", this._group.all().map(item => item.key));
        return this;
    }

    chartGroup(chartGroup) {
        if (!arguments.length) return this._chartGroup;
        this._chartGroup = chartGroup;
        return this;
    }

    valueAccessor(accessor) {
        if (!arguments.length) return this._valueAccessor;
        this._valueAccessor = accessor;
        return this;
    }

    filterState(filterState) {
        if (!arguments.length) return this._filterState;
        this._filterState = filterState instanceof Set ? filterState : new Set([...filterState]);
        return this;
    }


    mode(mode) {
        this._mode = mode;
        return this;
    }

    title(title) {
        this._title = title;
        return this;
    }

    // show selectall button only for certain charts
    showSelectButtons(show) {
        this._showSelectButtons = show;
        return this;
    }

    redraw(){
        this._doRender();
    }

    hideInactiveItems(hideInactiveItems) {
        this._hideInactiveItems = hideInactiveItems;
        return this;
    }

    _doRender() {
        if (!this.parentElement) {
            this.parentElement = document.querySelector(this.parentElementSelector);
        }
        this.parentElement.innerHTML = "";

        // the parent element will be created new for each update of the chart list
        // i.e. for reusing chart display, we create our own parent element inside of it

        const localParent = document.createElement("div");
        this.parentElement.appendChild(localParent);

        // we reset the localParent as parent element for the initial display
        // and as the domroot for reuse of the chart
        this.parentElement = localParent;
        this.domroot = this.parentElement;

        // if we need to set title directly here
        /*const title = document.createElement("h4");
        title.textContent = this._title || "Select Items";
        this.parentElement.appendChild(title);*/

        // Check mode and render accordingly
        if (this._mode === MODE_TEXTINPUT_AUTOCOMPLETE) {
            this.renderAutocompleteMode();
        } else if (this._mode === MODE_TEXTINPUT_DROPDOWN_SELECT) {
            this.renderDropdownMode();
        } else if (this._mode === MODE_TEXTINPUT_TIME_INTERVAL){
            this.renderTimeIntervalMode();
        } else {
            this.renderCheckboxMode();
        }
        return this;
    }

    renderCheckboxMode() {
        // Create a container div for the buttons
        const checkboxContainer = document.createElement("div");
        checkboxContainer.style.display = "flex";
        checkboxContainer.style.gap = "10px";
        checkboxContainer.style.marginBottom = "10px";
        checkboxContainer.style.marginTop = "5px";


        // Create "Select All" and "Unselect All" buttons
        if (this._showSelectButtons) {
        const selectAllButton = document.createElement("button");
        selectAllButton.textContent = "Alle auswählen";
        selectAllButton.className = "textchart-btn textchart-btn-select";
        selectAllButton.addEventListener("click", () => this.selectAllboxes());
        checkboxContainer.appendChild(selectAllButton);

        const unselectAllButton = document.createElement("button");
        unselectAllButton.textContent = "Alle abwählen";
        unselectAllButton.className = "textchart-btn textchart-btn-unselect";
        unselectAllButton.addEventListener("click", () => this.unselectAllboxes());
        checkboxContainer.appendChild(unselectAllButton);
        }

        this.parentElement.appendChild(checkboxContainer);

        // Container for selected items (bubbles)
        const bubbleContainer = document.createElement("div");
        bubbleContainer.className = "bubble-container";
        this.parentElement.appendChild(bubbleContainer);

        this._group.all().forEach(item => {
            const checkbox = document.createElement("input");
            checkbox.type = "checkbox";
            checkbox.value = item.key;
            checkbox.id = "checkbox-" + (idcount++);
            checkbox.className = "bubble";


            const itemValue = this._valueAccessor(item);
            const isActive = itemValue > 0;

            // Sync checkbox state with filter state
            checkbox.checked = this._filterState.has(item.key);
            checkbox.disabled = !isActive; // Disable if not active

            /*// Style the checkbox for disabled state
            if (!isActive) {
                checkbox.style.opacity = "0.5"; // Grey-out
                checkbox.style.pointerEvents = "none"; // Make it non-interactive
            }*/

            checkbox.addEventListener("change", () => {
                this.updateFilterState(item.key, checkbox.checked);
            });

            // Skip rendering checkboxes and labels
            //this.parentElement.appendChild(checkbox);

            const label = document.createElement("label");
            const count = this._valueAccessor(item); // Use value accessor for count
            label.textContent = `${item.key} (${count})`;
            label.setAttribute("for", checkbox.id);
            label.className = isActive ? "textchart-label" : "textchart-label-disabled";

            /*if (!isActive) {
                label.style.color = "gray"; // Grey-out the label if not active
            }*/
            // Skip rendering checkboxes and labels
            //this.parentElement.appendChild(label);
            this.updateBubbles(bubbleContainer);
        });

        //return this;
    }

    renderAutocompleteMode() {
        const input = document.createElement("input");
        input.setAttribute("placeholder", "Texteingabe...");
        input.className = "textchart-autocomplete";
        this.parentElement.appendChild(input);

        // Container for displaying autocomplete suggestions
        const suggestionContainer = document.createElement("div");
        suggestionContainer.className = "dropdown-container";
        suggestionContainer.style.display = "none"; // Initially hidden
        this.parentElement.appendChild(suggestionContainer);

        // Container for displaying selected items as bubbles
        const bubbleContainer = document.createElement("div");
        bubbleContainer.className = "textchart-bubble-container";
        this.parentElement.appendChild(bubbleContainer);

        // Render suggestions dynamically
        const updateSuggestions = (query = "") => {
            suggestionContainer.innerHTML = "";
            if (query.trim() === "") {
                suggestionContainer.style.display = "none"; // Hide if no query
                return;
            }
            suggestionContainer.style.display = "block"; // Show container

            this._group.all().forEach((item) => {
                if (!item.key.toLowerCase().includes(query.toLowerCase())) return;

                const suggestionItem = document.createElement("div");
                suggestionItem.className = "textchart-dropdown-item";
                suggestionItem.textContent = `${item.key} (${this._valueAccessor(item)})`;

                const itemValue = this._valueAccessor(item);
                const isActive = itemValue > 0;

                // Styling logic for inactive or selected items
                if (!isActive) {
                    suggestionItem.classList.add("disabled");
                    //suggestionItem.style.color = "#595B5C";
                    //suggestionItem.style.pointerEvents = "none"; // Disable selection
                } else if (this._filterState.has(item.key)) {
                    suggestionItem.classList.add("selected");
                    //suggestionItem.style.fontWeight = "bold";
                }

                suggestionItem.addEventListener("click", () => {
                    //this.updateFilterState(item.key);
                    this.updateFilterState(item.key, !this._filterState.has(item.key));

                    //this.toggleSelection(item.key);
                    this.updateBubbles(bubbleContainer);
                    input.value = "";
                    suggestionContainer.style.display = "none";

                    setTimeout(() => {
                        suggestionContainer.style.display = "none"; // Hide suggestions
                    }, 100);
                });

                if (isActive || !this._hideInactiveItems) {
                    suggestionContainer.appendChild(suggestionItem);
                }
            });
        };

        input.addEventListener("input", e => updateSuggestions(e.target.value));

        this.updateBubbles(bubbleContainer);
        this.on("postRedraw", () => this.updateBubbles(bubbleContainer));

        dc.chartRegistry.list(this._chartGroup).forEach((chart) => {
            chart.on("filtered", () => {
                if (input.value.trim() !== "") {
                    updateSuggestions(input.value);
                }
            });
        });
    }

    renderDropdownMode() {
        // Create the dropdown button
        const dropdownButton = document.createElement("button");
        dropdownButton.textContent = "Auswahl ▼";
        dropdownButton.className = "textchart-dropdown";
        dropdownButton.addEventListener("click", () => {
            const isOpen = dropdownContainer.classList.toggle("show");
            console.log(`[Dropdown] Toggled dropdown: ${dropdownContainer.classList.contains("show") ? "Opened" : "Closed"}`);

            if (isOpen) {
                dropdownContainer.focus(); // Focus the dropdown container to capture keyboard input
            } else {
                // Reset search buffer and repopulate the list when closing
                searchBuffer = "";
                updateDropdownItems();
            }
        });
        this.parentElement.appendChild(dropdownButton);

        // Create the dropdown container
        const dropdownContainer = document.createElement("div");
        dropdownContainer.className = "dropdown-container";
        dropdownContainer.tabIndex = 0; // Make it focusable for keyboard events
        this.parentElement.appendChild(dropdownContainer);

        // Container for selected items (bubbles)
        const bubbleContainer = document.createElement("div");
        bubbleContainer.className = "textchart-bubble-container";
        this.parentElement.appendChild(bubbleContainer);

        let searchBuffer = ""; // Store typed characters
        let searchTimeout = null; // Timeout to clear the buffer

        // Render dropdown items dynamically based on the filtered data
        const updateDropdownItems = (query = "") => {
            console.log(`[Dropdown] Filtering items with query: "${query}"`);
            dropdownContainer.innerHTML = ""; // Clear previous items

            // Populate dropdown items based on the search query
            const filteredItems = this._group.all().filter(item =>
                item.key.toLowerCase().includes(query.toLowerCase())
            );

            if (filteredItems.length === 0) {
                console.log("[Dropdown] No results found");
                const noResults = document.createElement("div");
                noResults.textContent = "No results found";
                noResults.className = "textchart-dropdown-item disabled";
                dropdownContainer.appendChild(noResults);
                return;
            }


            // Populate dropdown items
            filteredItems.forEach((item) => {
                const dropdownItem = document.createElement("div");
                dropdownItem.className = "textchart-dropdown-item";
                dropdownItem.textContent = `${item.key} (${this._valueAccessor(item)})`;

                // Get the item's value
                const itemValue = this._valueAccessor(item);
                const isActive = itemValue > 0;



                // Apply styles or disable based on value
                if (!isActive) {
                    dropdownItem.classList.add("disabled");
                    //dropdownItem.style.color = "gray";
                    //dropdownItem.style.color = "#595B5C";
                    //dropdownItem.style.pointerEvents = "none"; // Make unselectable
                } else if (this._filterState.has(item.key)) {
                    dropdownItem.classList.add("selected");
                }

                // Handle item selection
                dropdownItem.addEventListener("click", () => {
                    if (isActive) {
                        //this.toggleSelection(item.key);
                        this.updateFilterState(item.key, !this._filterState.has(item.key));
                    }
                });

                if (isActive || !this._hideInactiveItems) {
                    dropdownContainer.appendChild(dropdownItem);
                }
            });
        };
        // Handle keyboard input for searching
        dropdownContainer.addEventListener("keydown", (e) => {
            if (e.key === "Escape") {
                console.log("[Dropdown] Escape key pressed. Closing dropdown.");
                dropdownContainer.classList.remove("show");
                return;
            }

            if (e.key === "Backspace") {
                searchBuffer = searchBuffer.slice(0, -1); // Remove last character
                console.log(`[Dropdown] Backspace pressed. Updated search buffer: "${searchBuffer}"`);

            } else if (e.key.length === 1) {
                searchBuffer += e.key; // Add typed character to the buffer
                console.log(`[Dropdown] Typed character "${e.key}". Updated search buffer: "${searchBuffer}"`);
            }

            // Clear the buffer after a delay
            if (searchTimeout) clearTimeout(searchTimeout);
            searchTimeout = setTimeout(() => {
                console.log("[Dropdown] Clearing search buffer due to inactivity");
                searchBuffer = "";
            }, 3000);

            updateDropdownItems(searchBuffer);
        });

        // Redraw the dropdown items when the chart or group is updated
        this.on("postRedraw", () => {
            updateDropdownItems();
            this.updateBubbles(bubbleContainer);
        });
        updateDropdownItems();
        this.updateBubbles(bubbleContainer);
    }

    renderTimeIntervalMode(attribute = "begin") {
        const container = document.createElement("div");
        container.className = "textchart-time-interval";

        const fromInput = document.createElement("input");
        fromInput.type = "number";
        fromInput.className = "textchart-time-input";
        //fromInput.style.width = "80px";

        const toInput = document.createElement("input");
        toInput.type = "number";
        toInput.className = "textchart-time-input";
        //toInput.style.width = "80px";

        const applyButton = document.createElement("button");
        applyButton.textContent = "Anwenden";
        applyButton.className = "textchart-time-apply-btn";

        const bubbleContainer = document.createElement("div");
        bubbleContainer.className = "textchart-bubble-container";

        container.appendChild(fromInput);
        container.appendChild(toInput);
        container.appendChild(applyButton);
        container.appendChild(bubbleContainer);
        this.parentElement.appendChild(container);

        // Store the original range
        let dynamicRange = { min: null, max: null };

        // Function to calculate the full range of the dataset
        const calculateFullRange = () => {
            const allData = this._dimension.top(Infinity);
            if (allData.length > 0) {
                const values = allData
                    .map(d => d[attribute])
                    .filter(value => value !== null && !isNaN(value) && value > 0); // Exclude null or invalid values

                if (values.length > 0) {
                    return { min: Math.min(...values), max: Math.max(...values) };
                }
            }
            return { min: 1, max: 0 };
        };

        // Update the range dynamically based on current filters or the full dataset
        const updateRange = () => {
            const range = calculateFullRange();
            dynamicRange = range;

            fromInput.min = range.min;
            fromInput.max = range.max;
            toInput.min = range.min;
            toInput.max = range.max;

            fromInput.value = range.min;
            toInput.value = range.max;

            fromInput.placeholder = `from (${range.min})`;
            toInput.placeholder = `to (${range.max})`;
        };

        // Function to update input placeholders dynamically based on filtered data
        /*const updateTimeIntervalRange = () => {
            const filteredData = this._dimension.top(Infinity);

            if (filteredData.length > 0) {
                const values = filteredData
                    .map(d => d[attribute])
                    .map(value => (value && value !== "null" && !isNaN(value) ? parseInt(value, 10) : 3000)) // Handle invalid values
                    .filter(value => !isNaN(value)); // Ensure valid numbers only

                if (values.length > 0) {
                    const minFilteredValue = Math.min(...values);
                    const maxFilteredValue = Math.max(...values);

                    // Update the dynamic range
                    dynamicRange = { min: minFilteredValue, max: maxFilteredValue };

                    // Update input placeholders and default values
                    fromInput.placeholder = `from (${minFilteredValue})`;
                    toInput.placeholder = `to (${maxFilteredValue})`;

                    fromInput.min = minFilteredValue;
                    fromInput.max = maxFilteredValue;
                    toInput.min = minFilteredValue;
                    toInput.max = maxFilteredValue;

                    if (!fromInput.value || fromInput.value < minFilteredValue || fromInput.value > maxFilteredValue) {
                        fromInput.value = minFilteredValue;
                    }
                    if (!toInput.value || toInput.value < minFilteredValue || toInput.value > maxFilteredValue) {
                        toInput.value = maxFilteredValue;
                    }
                }
            }
        };
*/
        // Function to update bubbles dynamically
        const updateBubbles = () => {
            bubbleContainer.innerHTML = "";

            if (this._filterState.size > 0) {
                //const [range] = this._filterState;
                const [range] = Array.from(this._filterState);

                const [from, to] = range.split("-").map(Number);

                const bubble = document.createElement("span");
                bubble.className = "bubble";
                bubble.textContent = `${from} - ${to}`;

                const removeButton = document.createElement("button");
                removeButton.className = "remove-button";
                removeButton.textContent = "x";
                removeButton.addEventListener("click", () => {
                    this._filterState.clear(); // Clear filter state
                    this._dimension.filterAll(); // Clear the filter

                    // Trigger 'filtered' event for immediate updates
                    //the call to onFiltered only happens if onFiltered is defined and is a callable function
                    this.onFiltered?.();

                    updateRange();
                    updateBubbles();
                    dc.redrawAll(this._chartGroup); // Redraw all charts
                });

                bubble.appendChild(removeButton);
                bubbleContainer.appendChild(bubble);
            }
            // // Emit a custom 'filtered' event
            // if (typeof this.onFiltered === 'function') {
            //     this.onFiltered();
            // }
        };

        // Event listener for the "Apply" button
        applyButton.addEventListener("click", () => {
            const fromValue = parseInt(fromInput.value, 10);
            const toValue = parseInt(toInput.value, 10);

            if (
                !isNaN(fromValue) &&
                !isNaN(toValue) &&
                fromValue >= dynamicRange.min &&
                toValue <= dynamicRange.max &&
                fromValue <= toValue
            ) {

                console.log("Resetting time interval filter before applying.");
                this._dimension.filterAll(); // Clear previous filters for time
                this._dimension.filterRange([fromValue, toValue + 1]); // Apply new filter

                this._filterState.clear();
                this._filterState.add(`${fromValue}-${toValue}`); // Sync with filter state
                this.onFiltered?.();

                updateBubbles();
                dc.redrawAll(this._chartGroup);
            } else {
                alert(`Please enter valid values between ${dynamicRange.min} and ${dynamicRange.max}, with "from" <= "to".`);
            }
        });

        // Automatically update inputs when filters are applied from other charts
        this.on("postRedraw", () => {
            if (this._filterState.size === 0) {
                updateRange(); // Reset to the full range
            }
            updateBubbles();
        });

        // Initialize the inputs with the default or current range
        updateRange();
        //updateTimeIntervalRange();
        updateBubbles();
    }


    updateBubbles(bubbleContainer) {
        //const bubbleContainer = this.parentElement.querySelector(".bubble-container");
        if (!bubbleContainer) {
            console.warn("Bubble container not found. Skipping update.");
            return;
        }
        bubbleContainer.innerHTML = ""; // Clear existing bubbles

        //console.log("Selected Values:", [...this._selectedValues]);
        console.log("Current Filter State:", [...this._filterState]);

    if (this._mode !== MODE_CHECKBOX) {
        this._filterState.forEach(value => {
            const bubble = document.createElement("span");
            bubble.className = "bubble";
            bubble.textContent = value;

            // Check if the value is part of the filtered data
            const isActive = Array.from(this._dimension.top(Infinity)).some(d => Object.values(d).includes(value));

            // Check if the value is part of the active (filtered) data
            if (!isActive) {
                bubble.classList.add("inactive");
            } else {
                bubble.classList.remove("inactive");
            }

            const removeButton = document.createElement("button");
            removeButton.className = "remove-button";
            removeButton.textContent = "x";
            removeButton.addEventListener("click", () => {
                this.updateFilterState(value, false);
                this.updateBubbles(bubbleContainer);
            });

            bubble.appendChild(removeButton);
            bubbleContainer.appendChild(bubble);
        });
    } else {
        // Checkbox mode: use special bubble settings
        this._group.all().forEach(item => {
            const bubble = document.createElement("span");
            bubble.className = "bubble";
            bubble.textContent = `${item.key} (${this._valueAccessor(item)})`;

            const itemValue = this._valueAccessor(item);
            const isActive = itemValue > 0;
            const isSelected = this._filterState.has(item.key);

            // if (isSelected) {
            //     // Style for selected items (default blue bubble)
            //     bubble.classList.add("selected");
            // we could make difference between selected but not more available items
            // but if this is not important, we could commit it out, so we have general design
            if (isSelected && !isActive) {
                // New style for selected items with value 0 due to filtering
                //bubble.classList.add("filtered-out");
                bubble.classList.add("inactive");

            }
            else if (isSelected) {
                // Style for selected items (default blue bubble)
                bubble.classList.add("selected");

            } else if (isActive) {
                // Style for not marked but available items (white bubble)
                bubble.classList.add("available");
            } else {
                // Style for not marked and not available items (inactive bubble)
                bubble.classList.add("inactive");
            }

            // Make bubbles clickable to toggle selection
            bubble.addEventListener("click", () => {
                const newState = !isSelected;
                this.updateFilterState(item.key, newState);
                this.updateBubbles(bubbleContainer);
            });

            // Add remove button for selected bubbles
            if (isSelected) {
                const removeButton = document.createElement("button");
                removeButton.className = "remove-button";
                removeButton.textContent = "x";
                removeButton.addEventListener("click", () => {
                    this.updateFilterState(item.key, false);
                    this.updateBubbles(bubbleContainer);
                });
                bubble.appendChild(removeButton);
            }

            bubbleContainer.appendChild(bubble);
        });

    }
    }

    updateFilterState(value, add) {
        if (add) {
            this._filterState.add(value);
        } else {
            this._filterState.delete(value);
        }

        // Apply filter or reset to initial state
        if (this._filterState.size > 0) {
            this.filter(Array.from(this._filterState));
        } else {
            this._dimension.filterAll();
        }
        // Emit a custom 'filtered' event
        if (typeof this.onFiltered === 'function') {
            this.onFiltered();
        }
        dc.redrawAll(this._chartGroup);
    }

    // Maybe we need it later on
    _doRedraw() {
        /*const filteredData = this._dimension.top(Infinity);
        this._allCheckboxesAndValues.forEach(boxAndValue => {
            boxAndValue.checkbox.checked = this.isItemFiltered(boxAndValue.value, filteredData);
        });*/
        //this.updateDropdownButtonText();
        return this;
    }

    filter(filters) {
        if (!arguments.length) {
            return this._dimension.filterFunction ? this._dimension.currentFilter() : null;
        }
        if (filters === null) {
            this._dimension.filter(null);
        } else if (Array.isArray(filters)) {
            this._dimension.filter(d => filters.includes(d));
        } else {
            this._dimension.filter(filters);
        }
        //this._doRedraw()
        //dc.redrawAll(this._chartGroup);
        return this;
    }

    selectAllboxes() {
        this._group.all().forEach(item => {
            if (this._valueAccessor(item) > 0) this._filterState.add(item.key);
        });
        this.filter(Array.from(this._filterState));
        this.onFiltered?.();
        dc.redrawAll(this._chartGroup);
    }

    unselectAllboxes() {
        this._filterState.clear();
        this.filter(null);
        this.onFiltered?.();
        dc.redrawAll(this._chartGroup);
    }

}
